<template>
  <a class="add-new-app">
    <span class="icon">
      <i class="mdi mdi-plus"></i>
    </span>
    <p class="add-new-app-heading">Add new application</p>
  </a>
</template>

<script>
export default {
  name: "AddApplicationCard"
};
</script>

<style lang="scss" scoped>
@import "~scss/utilities/initial-variables.scss";
@import "~scss/utilities/derived-variables.scss";

.add-new-app {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 2rem 1rem;
  border-radius: $radius-extra-large;
  background-color: rgba($white, 1);
  box-shadow: 0 2px 4px 0 rgba($black, 0.02), 0 2px 12px 0 rgba($black, 0.06);
  transition: $transition;

  &:hover {
    box-shadow: 0 4px 4px 0 rgba($black, 0.02), 0 4px 12px 0 rgba($black, 0.06);

    .icon {
      &:before {
        transform: scale(1.2);
      }
    }

    .add-new-app-heading {
      color: rgba($black, 0.5);
    }
  }

  .icon {
    position: relative;
    display: flex;
    width: 1.75rem;
    height: 1.75rem;
    border-radius: 50%;
    background-color: rgba($black, 0.16);

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-image: linear-gradient(to bottom, #83bcff, #4a90e2);
      transform: scale(0);
      transition: $transition;
    }

    i {
      transform: translateY(1px);
      font-size: 1rem;
      color: $white;
    }
  }
}

.add-new-app-heading {
  color: rgba($black, 0.4);
  font-size: 1.3125rem;
  letter-spacing: 0.3px;
  margin-top: 0.5625rem;
  transition: $transition;
}
</style>
